import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { StyledFileList, DeleteButton, FileItem, FilePreview, FileIcon } from "./styled";
import { isImage } from "./lib/helper";
import { fileIcon } from "@/shared/assets/images";
import { TrashCanIcon } from "@/shared/assets/icons";
const FileList = ({ files, handleRemoveFile, loading }) => {
    if (files.length === 0 && !loading)
        return null;
    return (_jsxs(StyledFileList, { children: [files.map((file) => (_jsxs(FileItem, { children: [_jsx(DeleteButton, { onClick: () => handleRemoveFile(file.id), children: _jsx(TrashCanIcon, {}) }), isImage(file.format?.split("/").pop() ?? "") ? (_jsx(FilePreview, { children: _jsx(FileIcon, { src: file.data }) })) : (_jsx(FilePreview, { children: _jsx(FileIcon, { src: fileIcon }) }))] }, file.id))), loading && (_jsx(FileItem, { children: _jsx(FilePreview, { children: _jsx(CircularProgress, { id: "pictureLoaderId", color: "primary", size: 20 }) }) }, "loading"))] }));
};
export default FileList;
